
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SocialMediaHandlesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SocialMediaHandles"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facebook"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"github"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"instagram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkedin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"twitter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"youtube"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":131}};
    doc.loc.source = {"body":"fragment SocialMediaHandlesFragment on SocialMediaHandles {\n   facebook\n   github\n   instagram\n   linkedin\n   twitter\n   youtube\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
